import { AfterViewChecked, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { Image, Parking, parkingsPath, ParkingStatus, ParkingType, TrackingEntryType } from '@parkupp/core'
import { Router } from '@angular/router'
import { ParkingService } from '../../../services/parking.service'
import { CarouselConfig } from 'ngx-bootstrap/carousel'
import { SortImagesByDatePipe } from '../../core/pipes/sort-images-by-date.pipe'
import { SortImagesByPrimaryImagePipe } from '../../core/pipes/sort-images-by-primary-image.pipe'
import { TrackingService } from '../../../services/tracking.service'
import { doc } from '@angular/fire/firestore'
import { InViewportDirective } from '../../core/directives/inViewport.directive'
import { AuthenticationService } from '../../../services/authentication.service'

@Component({
    selector: 'app-parking-list-item',
    templateUrl: './parking-list-item.component.html',
    styleUrls: ['./parking-list-item.component.scss'],
    providers: [{ provide: CarouselConfig, useValue: { showIndicators: true, interval: 0, indicatorsByChunk: true, isAnimated: true } }],
})
export class ParkingListItemComponent implements OnInit, AfterViewChecked {
    @Input() parking: Parking
    @Input() merchantKey: string
    @Input() forMerchants = false
    @Input() highlighted: boolean
    @Output() onSelect = new EventEmitter<Parking>()
    @Output() onHover = new EventEmitter<Parking | null>()
    @ViewChild(InViewportDirective) inViewportDirective: InViewportDirective

    readonly ParkingType = ParkingType

    alreadyTracked = false
    emitEvent = true

    constructor(private router: Router, private parkingService: ParkingService, private trackingService: TrackingService, private authenticationService: AuthenticationService) {}

    ngOnInit(): void {}

    ngAfterViewChecked() {
        // Track the impression
    }

    onImpressionMade() {
        const userId = this.authenticationService.auth.currentUser?.uid
        const parkingRef = doc(this.parkingService.firestore, parkingsPath(), this.parking.$key as string)
        this.trackingService.addEntry(TrackingEntryType.IMPRESSION, parkingRef, userId)
        this.alreadyTracked = true
    }

    selected() {
        if (this.emitEvent) {
            this.onSelect.emit(this.parking)
        }
        this.emitEvent = true
    }
}
